const formatCurrency = (amount: number): string => {
  const formattedNumber = Number(amount).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formattedNumber;
};

export { formatCurrency };
